import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { NbAuthComponent } from './@theme/components/auth/auth.component';
import { NbAuthBlockComponent } from './@theme/components/auth/auth-block/auth-block.component';
import { NbLoginComponent } from './@theme/components/auth/login/login.component';
import { NbRegisterComponent } from './@theme/components/auth/register/register.component';
import { NbLogoutComponent } from './@theme/components/auth/logout/logout.component';
import { NbRequestPasswordComponent } from './@theme/components/auth/request-password/request-password.component';
import { NbResetPasswordComponent } from './@theme/components/auth/reset-password/reset-password.component';

const routes: Routes = [
  { path: '', loadChildren: 'app/pages/pages.module#PagesModule' },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
    ],
  },
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}